<div class="tape">
  <div class="dark-tape">
    <h2 class="work-plan"> - Our Strategic Process - </h2>
  </div>
  <div class="blue-tape">
    <app-marquee [autoFill]="true"
                 [direction]="'left'"
                 [isPlaying]="true"
                 [updateVisible]="false"
                 [pauseOnHover]="false">
      <div class="content">
        Discovery & Strategy
        <mat-icon>group_work</mat-icon>
        Architecture & UX Design
        <mat-icon>auto_fix_high</mat-icon>
        Agile Engineering & AI Integration
        <mat-icon>code</mat-icon>
        Deployment & Success
        <mat-icon>favorite</mat-icon>
      </div>
    </app-marquee>
  </div>
</div>
<div class="container">
  <div class="box">
    <span class="discussion"></span>
    <div class="content">
      <h2>Discovery & Strategy</h2>
      <p>
        We dive deep into your business goals and target audience.
        Our team defines the product roadmap and technical requirements to ensure a clear path for development
      </p>
    </div>
  </div>
  <div class="box">
    <span class="concept"></span>
    <div class="content">
      <h2>Architecture & UX Design</h2>
      <p>
        Every wireframe and design concept is built to be effective, scalable, and user-centric.
      </p>
    </div>
  </div>
  <div class="box">
    <span class="development"></span>
    <div class="content">
      <h2>Agile Engineering & AI Integration</h2>
      <p>
        Our developers build your high-performance product using modern tech stacks.
        We focus on clean code, security, and involving advanced features like AI.
      </p>
    </div>
  </div>
  <div class="box">
    <span class="customer"></span>
    <div class="content">
      <h2>Deployment & Success</h2>
      <p>
        We deliver a polished, market-ready solution.
        Our partnership continues with deployment support and optimization to ensure your long-term business growth.
      </p>
    </div>
  </div>
</div>
